import { render, staticRenderFns } from "./zlgl.vue?vue&type=template&id=3f9c2fd9&scoped=true"
import script from "./zlgl.vue?vue&type=script&lang=js"
export * from "./zlgl.vue?vue&type=script&lang=js"
import style0 from "./zlgl.vue?vue&type=style&index=0&id=3f9c2fd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9c2fd9",
  null
  
)

export default component.exports